export default __webpack_public_path__ + "static/media/Kitchen.727e202f.png";